import PreAuthorizationRequestSucess from './PreAuthorizationRequestSucess';

export default PreAuthorizationRequestSucess;